<input #el class="form-control m-input" type="text" placeholder="{{placeholder}}" [formControl]="control"
    [matAutocomplete]="auto" (focusout)="onAutoCompletionClosed()">

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayName"
    (optionSelected)="onDeptSelected($event.option.value)" (closed)="onAutoCompletionClosed()">
    <mat-option *ngFor="let option of searchResults | async" [value]="option">
        {{ displayName(option) }}
    </mat-option>
</mat-autocomplete>